import { subscribe } from '@/utils'
import { CLIENT_CODE } from '@/constants'

import { Params, Response } from '.'

const submit = async (params: Params): Promise<Response> => {
	try {
		const body = {
			...params,
			is_send_to_finance: false,
			partner_code: CLIENT_CODE
		}
		const res = await subscribe.post<Response>('sales/subscription-setup', body)
		return res.data
	} catch (e) {
		throw e
	}
}

export const service = {
	submit
}
